import './App.scss';
import { Route, Routes, BrowserRouter, useNavigate } from 'react-router-dom';
// import RatioLoginPage from './pages/ratio/login/RatioLoginPage';
// import RatioIndexPage from './pages/ratio/ratioIndexPage/ratioIndexPage';
import LoginPage from './pages/appointmentManagement/login/loginPage';
import IndexPage from './pages/appointmentManagement/indexPage/indexPage';
import { useState, useEffect } from 'react';
import { setToastHandler } from './common/Toast';
import Toast from './pages/commonViews/toast/toast';
function App() {
  const [toastMessage, setToastMessage] = useState<string | null>(null);
  const hideToast = () => {
    setToastMessage(null); // 隐藏 Toast
  };
  useEffect(() => {
    setToastHandler((msg: string) => {
      setToastMessage(msg); // 当调用 showToast 时更新状态，显示 Toast
    });
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* <Route path="/" element={<RatioLoginPage />} />
          <Route path="/ratio/*" element={<RatioIndexPage />} /> */}
          <Route path="/" element={<LoginPage />} />
          <Route path="/appointmentManagement/*" element={<IndexPage />} />
        </Routes>
      </BrowserRouter>
      {toastMessage && <Toast message={toastMessage} onClose={hideToast} />}
    </div>
  );
}

export default App;
